<div *ngIf="vendorLoader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>

<div id="vendorDetail" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header content-header">
                <button class="close close-btn" aria-label="Close" data-dismiss="modal" type="button" (click)="closeVendorModel(f)">
                    <i class="fa fa-close fa-md"></i>
                </button>
                <h4 class="modal-title">{{ modalHeader }} Vendor</h4>
            </div>
            <form #f="ngForm" name="form" novalidate>
                <div class="modal-body">
                    <div class="member-card">
                        <h4 class="filter-options mt-0">Personal Information</h4>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Vendor Name<span class="text-danger">*</span></label>
                                    <input
                                        id="vehiclename"
                                        class="form-control"
                                        #vehicle_name="ngModel"
                                        maxlength="100"
                                        name="vehicle_name"
                                        placeholder="Vendor Name"
                                        required
                                        type="text"
                                        [ngClass]="{ 'is-invalid': f.submitted && vehicle_name.invalid }"
                                        [(ngModel)]="vendorDetail.name"
                                    />
                                    <div *ngIf="f.submitted && vehicle_name.invalid" class="invalid-feedback">
                                        <div *ngIf="vehicle_name.errors.required">
                                            <span style="color: red">Vendor Name is required.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Priority<span class="text-danger">*</span></label>
                                    <select
                                        class="form-control"
                                        #priority="ngModel"
                                        name="priority"
                                        required
                                        [ngClass]="{ 'is-invalid': f.submitted && priority.invalid }"
                                        [(ngModel)]="vendorDetail.priority"
                                    >
                                        <option *ngFor="let priority of priorityList" [ngValue]="priority.id">
                                            {{ priority.name }}
                                        </option>
                                    </select>
                                    <div *ngIf="f.submitted && priority.invalid" class="invalid-feedback">
                                        <div *ngIf="priority.errors.required"><span style="color: red">Priority is required.</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Email<span class="text-danger">*</span></label>
                                    <input
                                        id="email"
                                        class="form-control"
                                        #email="ngModel"
                                        email
                                        maxlength="50"
                                        name="email"
                                        placeholder="Email"
                                        required
                                        type="text"
                                        [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
                                        [(ngModel)]="vendorDetail.contact.emailId"
                                    />
                                    <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                                        <div *ngIf="email.errors.required"><span style="color: red">Email is required.</span></div>
                                        <div *ngIf="email.errors.email">
                                            <span style="color: red">Email must be a valid email address.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Phone<span class="text-danger">*</span></label>
                                    <input
                                        id="addMobileNumber"
                                        class="form-control"
                                        #add_MobileNumber="ngModel"
                                        maxlength="14"
                                        minlength="14"
                                        name="add_MobileNumber"
                                        pattern="\(?\d+\)?[-.\s]?\d+[-.\s]?\d+"
                                        placeholder="(xxx) xxx-xxxx"
                                        required
                                        type="text"
                                        [ngClass]="{ 'is-invalid': f.submitted && add_MobileNumber.invalid }"
                                        [ngModel]="vendorDetail.contact.phoneNumber | phoneNumberPipe"
                                        (ngModelChange)="vendorDetail.contact.phoneNumber = $event"
                                    />
                                    <div *ngIf="f.submitted && add_MobileNumber.invalid" class="invalid-feedback">
                                        <div *ngIf="add_MobileNumber.errors.required">
                                            <span style="color: red">Phone Number is required.</span>
                                        </div>
                                        <div *ngIf="add_MobileNumber.errors.minlength">
                                            <span style="color: red">Phone must have 10 digits.</span>
                                        </div>
                                        <div *ngIf="add_MobileNumber.errors.pattern">
                                            <span style="color: red">Phone Number not valid.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Transport Type<span class="text-danger">*</span></label>
                                    <div class="form-check">
                                        <span *ngFor="let serviceTypes of serviceType; let i = index">
                                            <input
                                                id="exampleCheck{{ i }}"
                                                class="form-check-input"
                                                name="transport_type"
                                                type="checkbox"
                                                [checked]="serviceTypes.check"
                                                [value]="serviceTypes.type"
                                                (change)="serviceTypes.check = !serviceTypes.check"
                                            />
                                            <label
                                                class="form-check-label pl-2 mr-4 cursorPointer"
                                                for="exampleCheck{{ i }}"
                                                style="font-weight: 400"
                                                >{{ serviceTypes.type }}</label
                                            >
                                        </span>
                                        <div *ngIf="!fromValid" class="invalid-feedback">
                                            <span style="color: red">Transport Type is required.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Contracted<span class="text-danger">*</span></label>
                                    <div class="radio my-0">
                                        <label
                                            ><input
                                                #contract="ngModel"
                                                name="contract"
                                                required
                                                type="radio"
                                                [value]="true"
                                                [(ngModel)]="vendorDetail.isContracted"
                                            />Yes</label
                                        >
                                        <label class="ml-4"
                                            ><input
                                                #contract="ngModel"
                                                name="contract"
                                                required
                                                type="radio"
                                                [value]="false"
                                                [(ngModel)]="vendorDetail.isContracted"
                                            />No</label
                                        >
                                    </div>
                                    <div *ngIf="f.submitted && contract.invalid" class="invalid-feedback">
                                        <div *ngIf="contract.errors.required"><span style="color: red">Contracted is required.</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Block time maximum</label>
                                    <input
                                        id="block_time_maximum"
                                        class="form-control"
                                        #blockTimeMaximum="ngModel"
                                        max="1"
                                        min="0"
                                        name="blockTimeMaximum"
                                        placeholder="0.2"
                                        step="0.1"
                                        type="number"
                                        [ngClass]="{ 'is-invalid': f.submitted && blockTimeMaximum.invalid }"
                                        [(ngModel)]="vendorDetail.blockTimeMaximum"
                                    />
                                    <div *ngIf="f.submitted && blockTimeMaximum.invalid" class="invalid-feedback">
                                        <span style="color: red">Block time should be a decimal from 0 to 1.0</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="member-card">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="filter-options mt-0">Service Area</h4>
                            </div>
                            <button
                                class="text-color btn btn-link py-0"
                                [disabled]="vendorDetail.isNationwideEnabled"
                                (click)="addServiceArea()"
                            >
                                <i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>
                                <b>New</b>
                            </button>
                        </div>

                        <div class="row">
                            <div class="col-lg-1 d-flex align-items-center my-2">
                                <input
                                    id="isNationwide"
                                    class="m-0"
                                    type="checkbox"
                                    [ngModelOptions]="{ standalone: true }"
                                    [(ngModel)]="vendorDetail.isNationwideEnabled"
                                    (ngModelChange)="onIsNationwideToggle($event)"
                                />
                                <label class="m-0 ml-2 font-weight-500 line-height-2" for="isNationwide"> Nationwide </label>
                            </div>
                        </div>

                        <ng-container *ngIf="!vendorDetail.isNationwideEnabled">
                            <div *ngFor="let service of vendorServiceArea; let i = index" class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>State<span class="text-danger">*</span></label>
                                        <select
                                            id="state{{ i }}"
                                            class="form-control"
                                            #state="ngModel"
                                            name="state{{ i }}"
                                            required
                                            [ngClass]="{ 'is-invalid': f.submitted && state.invalid }"
                                            [(ngModel)]="service.stateId"
                                            (change)="selectState($event, i)"
                                        >
                                            <option disabled selected value="">Select State</option>
                                            <option *ngFor="let state of stateList" [value]="state?.stateId">
                                                {{ state?.stateName }}
                                            </option>
                                        </select>
                                        <div *ngIf="f.submitted && state.invalid" class="invalid-feedback">
                                            <div *ngIf="state.errors.required"><span style="color: red">State is required.</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="d-flex justify-content-between"
                                            ><span>City<span class="text-danger">*</span></span
                                            ><span
                                                *ngIf="vendorServiceArea.length > 1"
                                                class="mr-1 text-color cursorPointer"
                                                title="Remove Service Area"
                                                (click)="removeServiceArea(i)"
                                            >
                                                <i class="fa fa-minus-circle"></i></span
                                        ></label>
                                        <ng-multiselect-dropdown-angular7
                                            class="showAllOption"
                                            #city="ngModel"
                                            name="city{{ i }}"
                                            ngModel
                                            required
                                            [settings]="dropdownSettings"
                                            [data]="service.cityList"
                                            [ngClass]="{ 'is-invalid': f.submitted && city.invalid }"
                                            [placeholder]="'Select City'"
                                            [(ngModel)]="service.city"
                                            (onSelectAll)="onSelectAll($event)"
                                        >
                                        </ng-multiselect-dropdown-angular7>
                                        <div *ngIf="f.submitted && city.invalid" class="invalid-feedback">
                                            <div *ngIf="city.errors.required"><span style="color: red">City is required.</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <div class="member-card">
                        <h4 class="filter-options mt-0">Address Details</h4>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Address Type</label><span class="text-danger"> * </span>
                                    <select
                                        class="form-control"
                                        #addressType="ngModel"
                                        name="addressType"
                                        required
                                        [ngClass]="{ 'is-invalid': f.submitted && addressType.invalid }"
                                        [(ngModel)]="vendorDetail.address.addressLocationType"
                                    >
                                        <option disabled selected [value]="null">Select Address Type</option>
                                        <option *ngFor="let item of AddressType" name="addr_type" [value]="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <div *ngIf="f.submitted && addressType.invalid" class="invalid-feedback">
                                        <div *ngIf="addressType.errors.required">
                                            <span style="color: red">Address Type is required.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Address</label><span class="text-danger"> * </span>
                                    <div class="radio my-0">
                                        <label
                                            ><input
                                                #pvtOrPublic="ngModel"
                                                name="pvtOrPublic"
                                                required
                                                type="radio"
                                                [value]="false"
                                                [(ngModel)]="vendorDetail.address.isGlobal"
                                            />Private</label
                                        >
                                        <label class="ml-4"
                                            ><input
                                                #pvtOrPublic="ngModel"
                                                name="pvtOrPublic"
                                                required
                                                type="radio"
                                                [value]="true"
                                                [(ngModel)]="vendorDetail.address.isGlobal"
                                            />Public</label
                                        >
                                        <div *ngIf="f.submitted && pvtOrPublic.invalid" class="invalid-feedback">
                                            <div *ngIf="pvtOrPublic.errors.required">
                                                <span style="color: red">Field is required.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Street Address</label>
                                    <input
                                        id="CMStreetAddress"
                                        class="form-control"
                                        maxlength="150"
                                        name="streetAddress"
                                        placeholder="Street Address"
                                        type="text"
                                        [(ngModel)]="vendorDetail.address.streetAddress"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Zipcode</label>
                                    <input
                                        id="CMZipcode"
                                        class="form-control"
                                        #zipCode="ngModel"
                                        maxlength="5"
                                        minlength="3"
                                        name="Zipcode"
                                        pattern="[A-Za-z0-9]+"
                                        placeholder="Zipcode"
                                        type="text"
                                        [(ngModel)]="vendorDetail.address.zipcode"
                                    />
                                    <div *ngIf="f.submitted && zipCode.invalid" class="invalid-feedback">
                                        <div *ngIf="zipCode.errors.pattern">
                                            <span style="color: red">ZipCode not valid.</span>
                                        </div>
                                        <div *ngIf="zipCode.errors.minlength">
                                            <span style="color: red">ZipCode must have 3 or 5 digits.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>State<span class="text-danger">*</span></label>

                                    <select
                                        class="form-control"
                                        #state_add="ngModel"
                                        name="state_add"
                                        required
                                        [ngClass]="{ 'is-invalid': f.submitted && state_add.invalid }"
                                        [(ngModel)]="vendorDetail.address.stateId"
                                        (change)="getCityByState(vendorDetail.address.stateId)"
                                    >
                                        <option disabled selected value="">Select State</option>
                                        <option *ngFor="let item of stateList" name="state" [value]="item.stateId">
                                            {{ item?.stateName }}
                                        </option>
                                    </select>
                                    <div *ngIf="f.submitted && state_add.invalid" class="invalid-feedback">
                                        <div *ngIf="state_add.errors.required"><span style="color: red">State is required.</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>City<span class="text-danger">*</span></label>

                                    <select
                                        class="form-control"
                                        #city="ngModel"
                                        name="city"
                                        required
                                        [ngClass]="{ 'is-invalid': f.submitted && city.invalid }"
                                        [(ngModel)]="vendorDetail.address.city"
                                    >
                                        <option disabled selected value="">Select City</option>
                                        <option *ngFor="let addCity of cityList" [value]="addCity.cityName">
                                            {{ addCity.cityName }}
                                        </option>
                                    </select>
                                    <div *ngIf="f.submitted && city.invalid" class="invalid-feedback">
                                        <div *ngIf="city.errors.required"><span style="color: red">City is required.</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="header != 'Edit Customer'" class="member-card">
                        <h4 class="filter-options my-0">Files</h4>
                        <div class="float-right mb-3">
                            <input
                                id="vendorFileUpdate"
                                class="cursorPointer mt-2"
                                #fileInput
                                accept=".jpg,.jpeg,.png,.pdf"
                                multiple
                                name="vendorFile"
                                style="display: none"
                                type="file"
                                [(ngModel)]="vendorFile"
                                (input)="vendorFileUpload(vendorFile, 'vendorFileUpdate')"
                            />
                            <a *ngIf="!editAllFile1" class="py-2 px-3 mr-2 button_style cursorPointer" (click)="editVendorFileOpen()">
                                Add File
                            </a>
                            <a
                                *ngIf="chooseFile.length != 0 && !editAllFile1"
                                class="py-2 px-3 mr-2 button_style_edit cursorPointer"
                                (click)="editAllFile()"
                                >Edit File</a
                            >
                            <button
                                *ngIf="editAllFile1"
                                class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                type="button"
                                (click)="closeAll()"
                            >
                                <i class="fa fa-close fa-md"></i>
                            </button>
                            <button
                                *ngIf="editAllFile1"
                                class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                type="button"
                                (click)="closeViewFileModel()"
                            >
                                <i class="fa fa-check fa-md"></i>
                            </button>
                        </div>
                        <div class="tableMargin">
                            <table id="tblattach" class="table border-table" data-sort="false">
                                <thead class="table-thead">
                                    <tr>
                                        <td class="header_td p-2" style="border-bottom: 1px !important">
                                            <div class="header_container">
                                                <div class="header_title" style="width: 29.33%">File Name</div>
                                                <div class="header_title" style="width: 40.33%">File Type</div>
                                                <div class="header_title action">Action</div>
                                            </div>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let file of chooseFile | SearchByName: searchText1; let i = index">
                                        <td>
                                            <div class="row_container">
                                                <div class="title_container" [style.width]="isMobileDevice == true ? '30.33%' : '100%'">
                                                    <div class="row_title">File Name</div>
                                                    <div
                                                        *ngIf="!file.IsEditable"
                                                        class="row_detail text-color cursorPointer"
                                                        style="word-break: break-word"
                                                        (click)="downloadFile(file)"
                                                    >
                                                        {{ file.fileName }}.{{ file.extension }}
                                                    </div>
                                                    <div *ngIf="file.IsEditable" class="d-flex">
                                                        <input
                                                            id="file_name_edit{{ i }}"
                                                            class="form-control mr-2"
                                                            name="file_name_edit{{ i }}"
                                                            placeholder="File Name"
                                                            type="text"
                                                            [(ngModel)]="file.fileName"
                                                        />
                                                        <span class="mt-2"
                                                            ><b>.{{ file?.extension }}</b></span
                                                        >
                                                    </div>
                                                </div>
                                                <div class="title_container" [style.width]="isMobileDevice == true ? '40.33%' : '100%'">
                                                    <div class="row_title">File Type</div>
                                                    <input
                                                        *ngIf="file.IsEditable"
                                                        id="file_category_edit{{ i }}"
                                                        class="form-control"
                                                        name="file_category_edit{{ i }}"
                                                        type="text"
                                                        [(ngModel)]="file.fileType"
                                                    />
                                                    <div *ngIf="!file.IsEditable" class="row_detail" style="word-break: break-word">
                                                        {{ file?.extension }}
                                                    </div>
                                                </div>
                                                <div class="title_container">
                                                    <div class="row_title">Action</div>
                                                    <div class="row_detail">
                                                        <button
                                                            *ngIf="!file.IsEditable"
                                                            class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                                            title="Edit License"
                                                            (click)="fileEdit(i)"
                                                        >
                                                            <i class="fa fa-pencil-square"></i>
                                                        </button>
                                                        <button
                                                            *ngIf="!file.IsEditable"
                                                            class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                                            data-target="#message"
                                                            data-toggle="modal"
                                                            title="Remove{{ file.fileType }}file"
                                                            (click)="removeFileForPopup(i)"
                                                        >
                                                            <i class="fa fa-minus-circle"></i>
                                                        </button>
                                                        <button
                                                            *ngIf="file.IsEditable"
                                                            class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                                            type="button"
                                                            (click)="closeDisable(i)"
                                                        >
                                                            <i class="fa fa-close fa-md"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                        data-dismiss="modal"
                        type="button"
                        (click)="closeVendorModel(f)"
                    >
                        Cancel
                    </button>
                    <button class="flat-butt flat-info-butt flat-info-grad-butt save-btn" type="submit" (click)="submitVendorData(f)">
                        Save Changes
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
